import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/i18n/LanguageContext';
import { safeGetArray } from '@/lib/safeStorage';
import { getRoomById } from '@/data/rooms';
import { History } from 'lucide-react';

const RecentlyVisited = () => {
  const { t } = useLanguage();

  const recentRooms = useMemo(() => {
    const visitLog = safeGetArray<{ roomId: string; timestamp: number }>('room-visit-log');
    const seen = new Set<string>();
    const unique: string[] = [];
    for (let i = visitLog.length - 1; i >= 0 && unique.length < 5; i--) {
      const id = visitLog[i].roomId;
      if (!seen.has(id)) { seen.add(id); unique.push(id); }
    }
    return unique.map(id => getRoomById(id)).filter(Boolean);
  }, []);

  if (recentRooms.length === 0) return null;

  return (
    <div className="space-y-3">
      <h2 className="text-xs uppercase tracking-widest text-muted-foreground/40 flex items-center gap-2">
        <span className="w-1 h-1 rounded-full bg-muted-foreground/20" />
        <History className="w-3 h-3" /> {t('recently_visited') || 'Recently Visited'}
      </h2>
      <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
        {recentRooms.map((room) => room && (
          <Link key={room.id} to={room.path} className="flex-shrink-0 w-48 p-3 border border-border/20 rounded-xl hover:border-foreground/20 transition-all hover:-translate-y-0.5">
            <h3 className="text-sm font-light truncate">{t(`room_${room.id}`) !== `room_${room.id}` ? t(`room_${room.id}`) : room.title}</h3>
            <p className="text-[10px] text-muted-foreground/40 truncate mt-1">{t(`sub_${room.id}`) !== `sub_${room.id}` ? t(`sub_${room.id}`) : room.subtitle}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RecentlyVisited;
